import React from 'react';
import s from './MobileWizard.scss';
import classNames from 'classnames';

export interface MobileWizardProps {
  circlesNum: number;
  currentCircle: number;
}

const MobileWizard = (props: MobileWizardProps) => {
  return (
    <div className={s.wizard}>
      <div
        className={classNames(s.circle, {
          [s.isFullCircle]: true,
        })}
        data-hook="wizard-circle-1"
      >
        1
      </div>
      {[...Array(props.circlesNum - 1)].map((el, idx) => (
        <div className={s.innerWizard} key={idx}>
          <div
            className={classNames(s.line, {
              [s.isFullLine]: props.currentCircle >= idx + 2,
            })}
            data-hook={`wizard-line-${idx + 1}`}
          />
          <div
            className={classNames(s.circle, {
              [s.isFullCircle]: props.currentCircle >= idx + 2,
            })}
            data-hook={`wizard-circle-${idx + 2}`}
          >{`${idx + 2}`}</div>
        </div>
      ))}
    </div>
  );
};

export default MobileWizard;
